module.exports = __webpack_public_path__ + "static/media/sample.51029baf.pdf";